export default function ValidatorService() {
    const email = (email: string) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const phoneNumber = (number: string) => {
        const regex = /\(\d{2}\)\s\d{4,5}-?\d{4}/g;
        return regex.test(number);
    };

    const cpf = (cpf: string) => {

        if (!cpf) return false;
   
        // Remover caracteres não numéricos
        cpf = cpf.replace(/\D/g, '');

        // Verifica se o CPF tem exatamente 11 dígitos
        if (!/^\d{11}$/.test(cpf)) return false;

        // Verifica se todos os dígitos são iguais (ex: "111.111.111-11", "22222222222", etc.)
        if (/^(\d)\1{10}$/.test(cpf)) return false;

        let soma = 0, resto;

        // Cálculo do primeiro dígito verificador
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(9))) return false;

        soma = 0;

        // Cálculo do segundo dígito verificador
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.charAt(10))) return false;

        return true;

    };

    const date = (date: string) => {

        const dateChar = date.replace('/','').replace('/','').trim();
        if(dateChar.length !== 8) return false;

        const data = date.split("/");
        const isValid = new Date(`${data[2]}-${data[1]}-${data[0]}`);

        if (isNaN(isValid.getTime())) {
            return false;
        }
        else return true;
    }

    return {
        email,
        phoneNumber,
        cpf,
        date
    };
}